import React, { useCallback } from 'react';

import { expValEquals } from '@confluence/feature-experiments';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import { ADMIN_SHAREABLE_LINKS, HOME } from '@confluence/named-routes/entry-points/routes.ts';
import { ShareableLinkSiteAdminConfigurationLoader } from '@confluence/access-links/entry-points/ShareableLinkSiteAdminConfigurationLoader.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminShareableLinksConfigurationRoute = () => {
	const { push } = useRouteActions();

	const handleBack = useCallback(() => push(ADMIN_SHAREABLE_LINKS.toUrl()), [push]);

	if (!expValEquals('shareable_links_m0', 'isEnabled', true)) {
		return <Redirection name={HOME.name} />;
	}

	return <ShareableLinkSiteAdminConfigurationLoader onBack={handleBack} />;
};

AdminShareableLinksConfigurationRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'siteSettingsAccessLinksConfigurationScreen' },
	},
	sideNavigationId: ADMIN_HOME_ID,
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
